import React from "react";
import Header from "../MerchandiseStore/Header/Header";
import Footer from "../../components/partials/FooterComponent";
import { connect } from "react-redux";

const RefundPolicy = (props) => {
  return (
    <>
      <Header totalItems={props.totalItems} />
      <div className="container mb-5">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center font-weight-bold mt-4">Refund Policy</h1>
            <br />
            <div className="">
              <p>
                We have a no refund policy
                </p><p>
                We will send a new product if the product you have received is defective/ damaged/ if you have received the wrong item. As we do not have a reverse pickup facility yet, you are kindly requested to ship the product(s) back to us. Please pack the items securely to prevent any loss or damage during transit. For return, related queries (For eg. Shipping address, order id) mail us at contact@codeium.tech
              </p>
            </div>  
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    totalItems: state.cart.totalItems,
  };
};

export default connect(mapStateToProps)(RefundPolicy);
